import theme_icons from "../../icons.js";
import { IconSelectBox } from "../../components/icon-selectbox-new.js";
import { iconMap } from "../../theme/assets/block-icons/iconMap";
import "../../components/tabpanels-ui-store";

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { useEffect, useState } = wp.element;
const { useSelect, dispatch } = wp.data;
const { InspectorControls, InnerBlocks, RichText, ColorPalette, select } =
  wp.blockEditor;
const { ToggleControl, PanelBody, Button, TextControl, Modal } = wp.components;
const ALLOWED = ["rbt/tabpanel"];

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14" fill="currentColor">
    <path d="M166.2-16c-13.3 0-25.3 8.3-30 20.8L120 48 24 48C10.7 48 0 58.7 0 72S10.7 96 24 96l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0-16.2-43.2C307.1-7.7 295.2-16 281.8-16L166.2-16zM32 144l0 304c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304-48 0 0 304c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-304-48 0zm160 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176z" />
  </svg>
);

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14" height="14" fill="currentColor">
    <path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z" />
  </svg>
);

const ATTRIBUTES = {
  isAdding: {
    type: "boolean",
    default: false,
  },
  isEditing: {
    type: "boolean",
    default: false,
  },
  includeSocial: {
    type: "boolean",
    default: true,
  },
  tabs: {
    type: "array",
    default: [],
  },
  tabTitle: {
    type: "string",
    default: "",
  },
  tabId: {
    type: "string",
    default: "",
  },
  tabIdError: {
    type: "string",
    default: "",
  },
  tabIcon: {
    type: "object",
    default: null,
  },
  tabColor: {
    type: "string",
    default: "",
  },
  pagelink: {
    type: "string",
    default: null,
  },
  addLinkedForm: {
    type: "boolean",
    default: false,
  },
  applyText: {
    type: "string",
    default:""
  },
  postMeta: {
    type: "object",
    default: {},
  },
  hasHeading: {
    type: "boolean",
    default: true,
  },
};

// Tab icons are stored as { name } (older tabs also carry an svg string); render from iconMap by name
const TabIcon = ({ icon }) => {
  const IconComponent = iconMap[icon?.name];
  return IconComponent ? <IconComponent /> : null;
};

// Save output before the WP 7.1 update (no ARIA, icons from a stored svg string, applyText attribute ignored).
// Kept verbatim so existing posts still validate; do not edit. Only allowed changes: tab.icon.svg -> tab.icon?.svg,
// and the applyText TDZ fix (output-identical, see the NOTE below).
function legacySaveV1({ attributes }) {
    const { tabs, pagelink, addLinkedForm, applyText, postMeta } = attributes;

    // Read the post ID directly from the editor URL — reliable and no hook needed
    const postID = new URLSearchParams(window.location.search).get('post');

    function LeftTabs({ page }) {
      return (
        <ul className="tab-navigation nav-stacked" role="tablist">
          {tabs.map((tab, index) => {
            return (
              <li
                id={"ctrl-" + tab.tabid}
                data-tab-trigger={tab.tabid}
                className={index === 0 ? "nav-tab active" : "nav-tab"}
                style={{ color: tab.color }}
              >
                <a
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                  href={page + "#/tab/" + tab.tabid}
                  onclick="doTabMenuClick(event)"
                >
                  <div
                    className="icon-container"
                    style={{
                      maxWidth: "100%",
                      width: "24px",
                      height: "24px",
                      color: tab.color,
                    }}
                    dangerouslySetInnerHTML={{ __html: tab.icon?.svg }}
                  ></div>
                  <span className="tab-link-inner">{tab.title}</span>
                </a>
              </li>
            );
          })}
        </ul>
      );
    }

    const returnLinkedFormButton = () => {
      // NOTE: this used to read `const applyText = ... : applyText ?? "Inquire Here"`, a TDZ error under
      // NOTE: wp-scripts (the old Babel build turned it into `var`, so the attribute was never read).
      // NOTE: Kept output-identical: saved posts contain cta_text or "Inquire Here", never the attribute.
      const applyText = postMeta.cta_text ? postMeta.cta_text : "Inquire Here";
      const internalLink = pagelink.substring(pagelink.length - 1) === "/" ? pagelink + "apply/" + "?pid=" + postID : pagelink + "/apply/" + "?pid=" + postID;
      if (postMeta.hasOwnProperty('cta_external_link') && postMeta.cta_external_link) {
        return (
          <div className="program-button">
            <a className="button button-primary rbt-tabnav-button" data-process="carryParams" href={postMeta.cta_external_link.toString()}>{applyText}</a>
          </div>
        );
      } else {
        return (
          <div className="program-button">
            <a className="button button-primary rbt-tabnav-button" data-process="carryParams" href={internalLink}>{applyText}</a>
          </div>
        );
      }
    };

    return (
      <div className="rbt-tabpanels" data-process="setTabPanels">
        <div className="rbt-fixed left-col">
          <LeftTabs page={pagelink} />
          {addLinkedForm && returnLinkedFormButton()}
        </div>
        <div className="tab-panel-column">
          <ul className="rbt-tab-content" data-scroll-slug="content">
            <InnerBlocks.Content />
          </ul>
        </div>
      </div>
    );
}

const tabpanels = {
  title: "Greenheart Page Tabs",
  icon: theme_icons.greenheart,
  category: "greenheart",
  supports: {
    align: ["wide", "full"],
  },
  attributes: ATTRIBUTES,

  edit({ clientId, attributes, setAttributes }) {
    const {
      isAdding,
      isEditing,
      tabs,
      tabTitle,
      tabId,
      tabIcon,
      tabColor,
      tabIdError,
      pagelink,
      addLinkedForm,
      applyText,
      postMeta,
      hasHeading,
    } = attributes;
    const childBlocks = useSelect(
      (select) =>
        select("core/block-editor").getBlocksByClientId(clientId)[0]
          .innerBlocks,
    );
    const [activeTab, setActiveTab] = useState(0);
    const [tabPendingRemoval, setTabPendingRemoval] = useState(null);
    useEffect(() => {
      const activeTabId = tabs[activeTab]?.tabid;
      if (!activeTabId) return;

      dispatch("rbt/tabpanels-ui").setActiveTab(clientId, activeTabId);

      const targetBlock = childBlocks[activeTab];
      if (targetBlock) {
        dispatch("core/block-editor").selectBlock(targetBlock.clientId);
      }
      // childBlocks intentionally omitted: useSelect returns a new array
      // reference on every edit anywhere in the subtree (e.g. typing in a
      // nested list item), which would re-fire this effect and force
      // selectBlock() back onto the panel on every keystroke, stealing
      // focus from whatever is actually being edited. Only re-select when
      // the active tab itself changes.
    }, [tabs, activeTab, clientId]);

    /* Add an Apply Button if a linked Form exists */
    const { pm } = useSelect((select) => {
      const currentPostId = select("core/editor").getCurrentPostId();
      return { pm: select("core").getEntityRecord("postType", "page", currentPostId)?.meta };
    }, []);
    useEffect(() => {
      if (pm && JSON.stringify(pm) !== JSON.stringify(attributes.postMeta)) {
        setAttributes({ postMeta: pm });
      }
    }, [pm]);

    function setPageLink() {
      var page = wp.data.select("core/editor").getCurrentPost();
      setAttributes({ pagelink: page.link });
    }
    function validateTab(text) {
      const validText = text.match(/^[a-z0-9-]+$/);
      if (validText) {
        setAttributes({ tabId: text, tabIdError: "" });
      } else {
        setAttributes({
          tabId: text,
          tabIdError:
            "Invalid tab id. Use only lowercase alphanumeric and dashes.",
        });
      }
    }
    function resetForm() {
      setActiveTab(0);
      setAttributes({
        isAdding: false,
        isEditing: false,
        tabTitle: "",
        tabId: "",
        tabIdError: "",
      });
    }
    function addNewTab() {
      var newTab = {
        tabid: tabId,
        title: tabTitle,
        icon: tabIcon,
        color: tabColor,
      };

      const newTabPanelBlock = wp.blocks.createBlock("rbt/tabpanel", {
        tabid: tabId,
        title: tabTitle,
        hasHeading,
      });

      dispatch("core/block-editor").insertBlock(
        newTabPanelBlock,
        childBlocks.length,
        clientId,
      );
      setActiveTab(childBlocks.length);
      setAttributes({
        tabs: [...tabs, newTab],
        isAdding: false,
        tabTitle: "",
        tabId: "",
        tabIdError: "",
        tabIcon: null,
        tabColor: "",
      });
    }

    function editTab(id) {
      const targetTab = tabs.find((tab) => tab.tabid === id);
      const targetTabIndex = tabs.findIndex((tab) => tab.tabid === id);

      setActiveTab(targetTabIndex);

      setAttributes({
        isEditing: true,
        tabTitle: targetTab.title,
        originalTabId: targetTab.tabid,
        tabId: targetTab.tabid,
        tabIdError: "",
        tabIcon: targetTab.icon,
        tabColor: targetTab.color,
      });
    }

    function saveEditedTab() {
      const { originalTabId } = attributes;

      if (tabId && tabTitle && !tabIdError) {
        const editedTabIndex = tabs.findIndex((tab) => tab.tabid === originalTabId);

        const updatedTabs = [...tabs];
        updatedTabs[editedTabIndex] = {
          tabid: tabId,
          title: tabTitle,
          icon: tabIcon,
          color: tabColor,
        };

        setAttributes({
          tabs: updatedTabs,
          isEditing: false,
          tabTitle: "",
          tabId: "",
          tabIdError: "",
          tabIcon: null,
          tabColor: "",
        });

        const blockToEdit = childBlocks.find(
          (block) => block.attributes.tabid === originalTabId,
        );
        if (blockToEdit) {
          dispatch("core/block-editor").updateBlockAttributes(
            blockToEdit.clientId,
            {
              tabid: tabId,
              title: tabTitle,
              icon: tabIcon,
              color: tabColor,
            },
          );
        }
      }
    }
    function removeTab(id) {
      const updatedTabs = tabs.filter((tab) => tab.tabid !== id);

      const blockClientIdsToRemove = childBlocks
        .filter((block) => block.attributes.tabid === id)
        .map((block) => block.clientId);

      dispatch("core/block-editor").removeBlocks(blockClientIdsToRemove);

      setActiveTab(0);
      setAttributes({ tabs: updatedTabs });
    }
    function renderEditForm() {
      return (
        <div className="tab-editing-form">
          <p>Give the new tab a Title:</p>
          <RichText
            tagName="h3"
            value={tabTitle}
            onChange={(val) => setAttributes({ tabTitle: val })}
            placeholder="Tab Title"
          />
          <p>
            Give the new tab a URL slug (use only lowercase letters and numbers
            separated by dashes):
          </p>
          <TextControl
            style={{
              display: "block",
              borderRadius: "4px",
              border: "1px solid #e2e2e2",
            }}
            value={tabId}
            onChange={validateTab}
            placeholder="enter-tab-slug-here"
          />
          {tabIdError && <p style={{ color: "red" }}>{tabIdError}</p>}

          <p>
            <strong>Tab Icon:</strong>
          </p>
          <IconSelectBox
            currentIcon={tabIcon || { name: "None", svg: "" }}
            onSelectIcon={(selected) => {
              setAttributes({ tabIcon: selected });
            }}
          />
          <p>
            <strong>Tab Accent Color</strong>
          </p>
          <ColorPalette
            value={tabColor}
            onChange={(val) => setAttributes({ tabColor: val })}
          />
          <div
            className="edit-controls"
            style={{ display: "flex", gap: "20px" }}
          >
            {tabTitle && tabId && !tabIdError && (
              <Button
                className="button button-primary"
                onClick={isEditing ? saveEditedTab : addNewTab}
              >
                {isEditing ? "Save Tab" : "Add Tab"}
              </Button>
            )}
            <Button
              className="button primary button-primary"
              onClick={resetForm}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    }

    function LeftTabs({ page, tabs, setAttributes }) {
      const { dispatch } = wp.data;

      const handleMoveTab = (direction, index) => {
        const newTabs = [...tabs];
        const newIndex = direction === "up" ? index - 1 : index + 1;
        if (newIndex < 0 || newIndex >= tabs.length) return;

        const temp = newTabs[index];
        newTabs[index] = newTabs[newIndex];
        newTabs[newIndex] = temp;

        const blockToMove = childBlocks.find(
          (block) => block.attributes.tabid === tabs[index].tabid,
        );
        const blockToSwap = childBlocks.find(
          (block) => block.attributes.tabid === tabs[newIndex].tabid,
        );

        if (blockToMove && blockToSwap) {
          dispatch("core/block-editor").moveBlockToPosition(
            blockToMove.clientId,
            clientId,
            clientId,
            newIndex,
          );
          dispatch("core/block-editor").moveBlockToPosition(
            blockToSwap.clientId,
            clientId,
            clientId,
            index,
          );

          setAttributes({ tabs: newTabs, activeTab: 0 });
        } else {
          console.error("Error moving tabs");
        }
      };

      return (
        <div className="rbt-fixed updating">
          <span className="nav-tab-wrapper" role="tablist">
            {tabs.map((tab, index) => (
              <div
                key={tab.tabid}
                className="tabLink"
                style={{ color: tab.color }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  <div
                    id={"ctrl-" + tab.tabid}
                    className={index === activeTab ? "nav-tab active" : "nav-tab"}
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      cursor: "pointer",
                      minWidth: 0,
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setActiveTab(index);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        e.stopPropagation();
                        setActiveTab(index);
                      }
                    }}
                    role="tab"
                    tabIndex={0}
                    aria-selected={index === activeTab ? "true" : "false"}
                    aria-controls={tab.tabid}
                  >
                    <div
                      className="icon-container"
                      style={{
                        maxWidth: "100%",
                        width: "24px",
                        height: "24px",
                        color: tab.color,
                      }}
                    >
                      <TabIcon icon={tab.icon} />
                    </div>
                    <span className="tab-link-inner" style={{ flex: 1 }}>{tab.title}</span>
                  </div>
                  <div className="tab-actions" style={{ display: "flex", gap: "6px", flexShrink: 0 }}>
                    <button
                      className="move-tab-up"
                      disabled={index === 0}
                      onClick={() => handleMoveTab("up", index)}
                      style={{ fontSize: "16px" }}
                    >
                      ↑
                    </button>
                    <button
                      className="move-tab-down"
                      disabled={index === tabs.length - 1}
                      onClick={() => handleMoveTab("down", index)}
                      style={{ fontSize: "16px" }}
                    >
                      ↓
                    </button>
                    <Button
                      className="button button-secondary"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "4px" }}
                      onClick={() => editTab(tab.tabid)}
                      label="Edit tab"
                    >
                      <EditIcon />
                    </Button>
                    <Button
                      className="button button-primary"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "4px" }}
                      onClick={() => setTabPendingRemoval({ tabid: tab.tabid, title: tab.title })}
                      label="Remove tab"
                    >
                      <TrashIcon />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </span>
          {tabPendingRemoval && (
            <Modal
              title="Remove tab"
              onRequestClose={() => setTabPendingRemoval(null)}
            >
              <p>{`Remove the "${tabPendingRemoval.title}" tab? This can't be undone once you save the page.`}</p>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
                <Button variant="tertiary" onClick={() => setTabPendingRemoval(null)}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  isDestructive
                  onClick={() => {
                    removeTab(tabPendingRemoval.tabid);
                    setTabPendingRemoval(null);
                  }}
                >
                  Remove
                </Button>
              </div>
            </Modal>
          )}
        </div>
      );
    }

    return [
      <InspectorControls>
        <PanelBody title="Page Tabs">
          <p>
            <strong>Linked Apply Button?</strong>
          </p>
          <p>
            <em>Add an Apply Button at the bottom of the tabs </em>
          </p>
          <ToggleControl
            label="Add Apply Button"
            checked={addLinkedForm}
            onChange={() => setAttributes({ addLinkedForm: !addLinkedForm })}
          />
          {addLinkedForm && (
            <TextControl
              label="Apply Button Text"
              help="Leave empty to use the page's CTA text, or 'Inquire Here'."
              placeholder={postMeta?.cta_text || "Inquire Here"}
              value={applyText}
              onChange={(newText) => setAttributes({ applyText: newText })}
            />
          )}
          <p>
            <strong>Show Panel Headings?</strong>
          </p>
          <p>
            <em>Show the tab title as a heading at the top of each panel</em>
          </p>
          <ToggleControl
            label="Show Panel Headings"
            checked={hasHeading}
            onChange={() => {
              const newHasHeading = !hasHeading;
              setAttributes({ hasHeading: newHasHeading });
              childBlocks.forEach((block) => {
                dispatch("core/block-editor").updateBlockAttributes(
                  block.clientId,
                  { hasHeading: newHasHeading },
                );
              });
            }}
          />
          <p>
            <strong>Reset Tab Links</strong>
          </p>
          <em>
            Because of the way this component is written, if you need to update
            the page slug, push this button to flush the cached base link.
          </em>
          <br />
          <Button className="primary-button button" onClick={setPageLink}>
            Flush Links
          </Button>
        </PanelBody>
      </InspectorControls>,
      <div className="rbt-tabpanels">
        {(isAdding || isEditing) && renderEditForm()}
        {!isAdding && !isEditing && (
          <>
            <div className="tab-nav-column">
              {pagelink ? (
                <LeftTabs
                  page={pagelink}
                  tabs={tabs}
                  setAttributes={setAttributes}
                />
              ) : (
                setPageLink()
              )}
              <Button
                className="button button-primary"
                onClick={() => setAttributes({ isAdding: true })}
              >
                Add New Tab
              </Button>
            </div>
            <div className="tab-panel-column">
              <ul className={"rbt-tab-content"} data-scroll-slug="content">
                <InnerBlocks allowedBlocks={ALLOWED} renderAppender={false} />
              </ul>
            </div>
          </>
        )}
      </div>,
    ];
  },
  save({ attributes }) {
    const { tabs, pagelink, addLinkedForm, applyText, postMeta } = attributes;

    // Read the post ID directly from the editor URL — reliable and no hook needed
    const postID = new URLSearchParams(window.location.search).get('post');

    function LeftTabs({ page }) {
      return (
        <ul className="tab-navigation nav-stacked" role="tablist">
          {tabs.map((tab, index) => {
            return (
              <li
                id={"ctrl-" + tab.tabid}
                data-tab-trigger={tab.tabid}
                className={index === 0 ? "nav-tab active" : "nav-tab"}
                style={{ color: tab.color }}
                role="presentation"
              >
                <a
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                  href={page + "#/tab/" + tab.tabid}
                  onclick="doTabMenuClick(event)"
                  role="tab"
                  aria-selected={index === 0 ? "true" : "false"}
                  aria-controls={tab.tabid}
                >
                  <div
                    className="icon-container"
                    style={{
                      maxWidth: "100%",
                      width: "24px",
                      height: "24px",
                      color: tab.color,
                    }}
                  >
                    <TabIcon icon={tab.icon} />
                  </div>
                  <span className="tab-link-inner">{tab.title}</span>
                </a>
              </li>
            );
          })}
        </ul>
      );
    }

    const returnLinkedFormButton = () => {
      // The block's own "Apply Button Text" wins, then the page's CTA text, then the default
      const buttonText = applyText || postMeta.cta_text || "Inquire Here";
      const internalLink = pagelink.substring(pagelink.length - 1) === "/" ? pagelink + "apply/" + "?pid=" + postID : pagelink + "/apply/" + "?pid=" + postID;
      if (postMeta.hasOwnProperty('cta_external_link') && postMeta.cta_external_link) {
        return (
          <div className="program-button">
            <a className="button button-primary rbt-tabnav-button" data-process="carryParams" href={postMeta.cta_external_link.toString()}>{buttonText}</a>
          </div>
        );
      } else {
        return (
          <div className="program-button">
            <a className="button button-primary rbt-tabnav-button" data-process="carryParams" href={internalLink}>{buttonText}</a>
          </div>
        );
      }
    };

    return (
      <div className="rbt-tabpanels" data-process="setTabPanels">
        <div className="rbt-fixed left-col">
          <LeftTabs page={pagelink} />
          {addLinkedForm && returnLinkedFormButton()}
        </div>
        <div className="tab-panel-column">
          <ul className="rbt-tab-content" data-scroll-slug="content">
            <InnerBlocks.Content />
          </ul>
        </div>
      </div>
    );
  },
  deprecated: [
    {
      attributes: ATTRIBUTES,
      save: legacySaveV1,
    },
  ],
};
registerBlockType("rbt/tabpanels", tabpanels);
export default tabpanels;
